import { Grid, MenuItem } from "@material-ui/core";
import React from "react";
import Pagination from "react-js-pagination";
import { ITEMS_LIMIT } from "../../../constants";
import CustomInput from "../Input";
import angleRight from "../../../assets/icons/rightArrow.svg";
import angleLeft from "../../../assets/icons/leftArrow.svg";
import "./footer_pagination.scss";
export default function FooterPagination(props) {
  const { itemProps, title, totalLength, paginationProps } = props;

  return (
    <Grid container className="footerPagination">
      <Grid item lg={12}>
        <div className="show__option">
          <ul>
            <li>
              {totalLength > paginationProps.itemsCountPerPage ? (
                <div className="pagination">
                  <Pagination
                    {...paginationProps}
                    pageRangeDisplayed={5}
                    itemClass="page-item"
                    linkClass="page-link"
                    hideDisabled={true}
                    hideFirstLastPages={true}
                    nextPageText={
                      <img
                        src={angleRight}
                        className="arrowPage"
                        alt="Next Step Image"
                      />
                    }
                    prevPageText={
                      <img
                        src={angleLeft}
                        className="arrowPage"
                        alt="Back Step Image"
                      />
                    }
                  />
                  <span>Total : {totalLength} </span>
                </div>
              ) : (
                ""
              )}
            </li>
            {!props.hideShow && (
              <>
                {" "}
                <li>Show </li>
                <li>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      margin: "normal",
                      className: "add-screen-formcontrol pageNumber",
                    }}
                    inputProps={{
                      ...itemProps,
                      className: "input-add-screen mt-0 text-center",
                      select: true,
                    }}
                  >
                    {ITEMS_LIMIT.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </CustomInput>
                </li>
              </>
            )}
            {totalLength !== 0 ? <li>Showing {title}</li> : ""}
          </ul>
        </div>
      </Grid>
      <Grid item lg={4}></Grid>
    </Grid>
  );
}
